import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { showToast } from "../../../components/custom/custom-toast";
import { PAGE_SIZES, STATUS } from "../../../constants/status";
import { STRING_SUB_MENU } from "../../../constants/string";
import { useFetchData } from "../../../hooks/useFetch";
import { CountTabResponse } from "../../../models/response/count-tab-response";
import { EmployeeResponse } from "../../../models/response/employee";
import { API_ADMIN_ROUTER } from "../../../services/api-config";
import { BasePaginateResponse } from "../../../services/base-paginate-response";
import { toggleMenuContent } from "../../../store/themeConfigSlice";
import { AdminHeader } from "../component/admin-header";
import AdminTable from "../component/admin-table";
import { AdminChangeStatus } from "../component/modal/admin-change-status";
import { AdminCreate } from "../component/modal/admin-create";
import { AdminDetail } from "../component/modal/admin-detail";
import { AdminInfo } from "../component/modal/admin-info";
import { AdminUpdate } from "../component/modal/admin-update";

export const AdminPage = () => {
  const dispatch = useDispatch();
  dispatch(toggleMenuContent(STRING_SUB_MENU.ADMIN));

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDetail, setIsOpenDetail] = useState(false);
  const [isOpenInfo, setIsOpenInfo] = useState(false);
  const [isOpenChangeStatus, setIsOpenChangeStatus] = useState(false);
  const [isOpenResetPass, setIsOpenResetPass] = useState(false);
  const [dataObject, setDataObject] = useState<EmployeeResponse>(new EmployeeResponse());
  const [countTab, setCountTab] = useState<CountTabResponse>(new CountTabResponse());
  const [totalRecords, setTotalRecords] = useState(0);
  const [dataAdmin, setDataAdmin] = useState<EmployeeResponse[]>([]);
  const [refresh, setRefresh] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(PAGE_SIZES[0]);
  const [keySearch, setKeySearch] = useState("");
  const [status, setStatus] = useState(STATUS.ACTIVE);
  const [changeStatus, setChangeStatus] = useState(false);

  const { request: fetchDataCountTab, baseResponse: responses } = useFetchData.Get<CountTabResponse>();
  const {
    request: fetchDataEmployee,
    baseResponse: responsesData,
    loading,
  } = useFetchData.Get<BasePaginateResponse<EmployeeResponse[]>>();

  const handleCountTab = useCallback(() => {
    fetchDataCountTab({
      endPoint: API_ADMIN_ROUTER.API_GET_ADMIN_COUNT_TAB(),
      data: {
        key_search: keySearch,
      },
    });
    setChangeStatus(false);
    setRefresh(false);
  }, [fetchDataCountTab, keySearch]);

  useEffect(() => {
    handleCountTab();
  }, []);

  useEffect(() => {
    if (changeStatus) {
      handleCountTab();
    }
  }, [changeStatus, handleCountTab, refresh]);

  useEffect(() => {
    if (!responses) return;
    if (responses.status === 200) {
      setCountTab(responses.data);
    }
  }, [responses]);

  const handleData = () => {
    fetchDataEmployee({
      endPoint: API_ADMIN_ROUTER.API_GET_ADMIN(),
      data: {
        status: status,
        key_search: keySearch,
        page: page,
        limit: limit,
      },
    });
    setRefresh(false);
  };

  useEffect(() => {
    if (!responsesData) return;
    if (responsesData.status === 200) {
      setDataAdmin(responsesData.data.list);
      setTotalRecords(responsesData.data.total_record);
    } else {
      showToast({ message: responsesData.message, type: "error" });
    }
  }, [responsesData]);

  useEffect(() => {
    setPage(1);
  }, [keySearch, status]);

  useEffect(() => {
    if (refresh) handleData();
  }, [refresh]);
  useEffect(() => {
    handleData();
  }, [status, keySearch, limit, page]);

  return (
    <div className="flex flex-col gap-3">
      <AdminHeader setShowModalCreate={setIsOpen} countTab={countTab} setStatus={setStatus} />
      <AdminTable
        loadingTable={loading}
        dataAdmin={dataAdmin}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        keySearch={keySearch}
        setKeySearch={setKeySearch}
        totalRecords={totalRecords}
        setOpenModalUpdate={setIsOpenUpdate}
        setOpenModalDetail={setIsOpenDetail}
        setOpenModalChangeStatus={setIsOpenChangeStatus}
        setOpenModalResetPass={setIsOpenResetPass}
        setDataObject={setDataObject}
      />

      <AdminCreate
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        setIsOpenInfo={setIsOpenInfo}
        setDataObject={setDataObject}
        setRefresh={setRefresh}
      />

      {isOpenUpdate && (
        <AdminUpdate
          isOpen={isOpenUpdate}
          setIsOpen={setIsOpenUpdate}
          adminId={dataObject._id}
          setRefresh={setRefresh}
        />
      )}

      <AdminDetail adminId={dataObject._id} isOpenDetail={isOpenDetail} setIsOpenDetail={setIsOpenDetail} />

      <AdminInfo dataObject={dataObject} isOpenDetail={isOpenInfo} setIsOpenDetail={setIsOpenInfo} />

      <AdminChangeStatus
        isOpen={isOpenChangeStatus}
        setIsOpen={setIsOpenChangeStatus}
        dataObject={dataObject}
        setChangeStatus={setChangeStatus}
        setRefresh={setRefresh}
      />
      <AdminChangeStatus
        isOpen={isOpenResetPass}
        setIsOpen={setIsOpenResetPass}
        dataObject={dataObject}
        type={STATUS.ACTIVE}
        setIsOpenInfo={setIsOpenInfo}
        setDataObject={setDataObject}
      />
    </div>
  );
};
